

// eslint-disable-next-line no-unused-vars
const  KcpTableHeaders = (_this) => {
    return {
        countCells: 8,
        massive: [
            {
                dataField: 'orgName',
                cols: 1,
                rows: 1,
                text: 'Наименование организации / филиала',
                order: 0,
                sortable: true,
                typeCell: 'string',
                variable: true,
                class: 'text-center',
                headerClass: 'text-center',
                template: (row) => {
                    return row['orgName'];
                }
            },
            {
                dataField: 'specCode',
                cols: 1,
                rows: 1,
                text: 'Код УГСН / НП(С)',
                order: 1,
                sortable: true,
                typeCell: 'string',
                variable: true,
                template: (row) => {
                    return row['kcpGroupCode'];
                }
            },
            {
                dataField: 'specName',
                cols: 1,
                rows: 1,
                text: 'Наименование УГСН / НП(С)',
                order: 2,
                sortable: true,
                typeCell: 'string',
                variable: true,
                class: 'text-center',
                headerClass: 'text-center',
                template: (row) => {
                    return row['kcpGroupName'];
                }
            },
            {
                dataField: 'foName',
                cols: 1,
                rows: 1,
                text: 'Форма обучения',
                order: 3,
                sortable: true,
                typeCell: 'string',
                variable: true,
                template: (row) => {
                    return row['foName'];
                }
            },
            {
                dataField: 'ffName',
                cols: 1,
                rows: 1,
                text: 'Форма финансирования',
                order: 4,
                sortable: true,
                typeCell: 'string',
                class: 'text-center',
                headerClass: 'text-center',
                variable: true,
                template: (row) => {
                    return row['ffName'];
                }
            },
            {
                dataField: 'value',
                cols: 1,
                rows: 1,
                text: 'Количество выделенных мест',
                headerTooltip: _this.type === 'PAID' /*? () => {console.log('true',_this.type); return true;} : () => {console.log('false',_this.type); return false;}*/,
                headerTooltipShow: false,
                headerTooltipText: () => {
                    return 'Объем выделенных КЦП на 2024 г./ Места по договорам об оказании платных образовательных услуг'
                },
                order: 5,
                sortable: true,
                typeCell: 'number',
                variable: true
            },
            {
                dataField: 'sumPlaces',
                cols: 1,
                rows: 1,
                text: 'Сумма распределенных мест',
                order: 6,
                sortable: true,
                typeCell: 'number',
                variable: true
            },
            // {
            //     dataField: 'specialQuota',
            //     cols: 1,
            //     rows: 1,
            //     text: 'из них по особой квоте',
            //     order: 7,
            //     sortable: true,
            //     typeCell: 'number',
            //     variable: true
            // },
            {
                dataField: 'actions',
                cols: 1,
                rows: 1,
                text: '',
                order: 7,
                variable: true,
            },

        ],
        dialog: [
            {
                text: 'Наименование организации',
                dataField: "orgId",
                variableName: 'orgId',
                sprDataName: 'sprOrg',
                typeVar: "selector",
                emits: true,
                rules: 'customRules',
                customsRulesArray: [
                    v => v != null || 'Значение должно быть выбрано'
                ],
                order: 0,
            },
            {
                text: 'УГСН / НП(С)',
                dataField: "kcpGroupId",
                variableName: 'kcpGroupId',
                sprDataName: 'sprKcpGroup',
                typeVar: "selector",
                rules: 'customRules',
                customsRulesArray: [
                    v => v != null || 'Значение должно быть выбрано'
                ],
                order: 2,
            },
            {
                text: 'Форма обучения',
                dataField: "foId",
                variableName: 'foId',
                sprDataName: 'sprFo',
                typeVar: "selector",
                rules: 'customRules',
                customsRulesArray: [
                    v => v != null || 'Значение должно быть выбрано'
                ],
                order: 2,
            },
            {
                text: 'Форма финансирования',
                dataField: "ffId",
                variableName: 'ffId',
                sprDataName: 'sprFf',
                emits: true,
                typeVar: "selector",
                rules: 'customRules',
                customsRulesArray: [
                    v => v != null || 'Значение должно быть выбрано'
                ],
                order: 2,
            },

        ]
    };
}
export default KcpTableHeaders